import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import AvailableTranslationCacheName from "../../utils/AvailableTranslationCacheName";
import { importTranslation } from "../../api/importTranslation";
import { showReportToast } from "../../components/ui/ReportToast";

export function useImportTranslation(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importTranslation,
    onSuccess: (report) => {
      showReportToast({
        title: "Import done",
        counts: { updated: report.updated, skipped: report.skipped, rejected: report.rejected },
        rows: report.rows,
        successStatus: "updated",
        fileName: "import-report.csv",
      });
      queryClient.invalidateQueries(AvailableTranslationCacheName.getAvailableTranslation());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
